export const base = {
  karla: "Karla, sans-serif"
}

export type Base = Record<keyof typeof base, string>
